module.exports = __webpack_public_path__ + "img/de_h5.3a52b373.png";